import { useCallback, useEffect, useState } from 'react';

const storageKey = userId => `fg.chatCollapsed:${userId}`;

function readCollapsed(userId) {
  if (!userId) return false;
  try {
    return window.localStorage.getItem(storageKey(userId)) === 'true';
  } catch {
    return false;
  }
}

// Match chat history's browser-local persistence, partitioned by account.
export function useChatCollapse(userId) {
  const [preference, setPreference] = useState(() => ({
    userId, collapsed: readCollapsed(userId),
  }));

  useEffect(() => {
    setPreference({ userId, collapsed: readCollapsed(userId) });
  }, [userId]);

  // Never render another account's preference while its effect is pending.
  const collapsed = preference.userId === userId
    ? preference.collapsed : readCollapsed(userId);

  const setCollapsed = useCallback(value => {
    const next = value === true;
    setPreference({ userId, collapsed: next });
    if (!userId) return;
    try {
      window.localStorage.setItem(storageKey(userId), String(next));
    } catch {
      // Keep the toggle usable for this mount if browser storage is unavailable.
    }
  }, [userId]);

  return [collapsed, setCollapsed];
}
